<template lang="pug">
  b-form.service-notification-create-edit-form(@submit.stop.prevent="onSubmit")
    b-form-group(
      label="Día de notificaión"
      label-for="input-notification-day"
    )
      b-form-input#input-notification-day(
        v-model="form.day"
        type="number"
        :state="$v.$dirty ? !$v.form.day.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.day.required") Campo requerido
        b-form-invalid-feedback(:state="$v.form.day.between") El día debe estar entre 1 y 31
    b-form-group(
      label="Asunto de la notificación"
      label-for="input-notification-subject"
    )
      b-form-input#input-notification-subject(
        v-model="form.subject"
        :state="$v.$dirty ? !$v.form.subject.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.subject.required") Campo requerido
    b-form-group(
      label="Mensaje"
      label-for="input-notification-message"
    )
      b-form-textarea#input-notification-message(
        v-model="form.message"
        rows="4"
        :state="$v.$dirty ? !$v.form.message.$invalid : null"
      )
      .errors(v-if="$v.$dirty")
        b-form-invalid-feedback(:state="$v.form.message.required") Campo requerido
    .modal-footer
      b-button(@click="$emit('cancel')" variant="outline-muted") Cancelar
      b-button.boton(type="submit") {{editMode?'Guardar':'Agregar'}}
</template>

<script>
import { required, between } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'

export default {
  props: {
    editMode: Boolean,
    serviceId: Number,
    notification: Object
  },
  data () {
    return {
      form: {
        day: this.editMode ? this.notification.day : 1,
        subject: this.editMode ? this.notification.subject : '',
        message: this.editMode ? this.notification.message : ''
      }
    }
  },
  validations: {
    form: {
      day: {
        required,
        between: between(1, 31)
      },
      subject: {
        required
      },
      message: {
        required
      }
    }
  },
  methods: {
    ...mapActions(['createServiceNotification', 'updateServiceNotification']),
    async onSubmit () {
      if (this.$v.$invalid) {
        this.$v.$touch()
      } else {
        let response
        
        if (this.editMode) {
          response = await this.updateServiceNotification({ 
            data: this.form,
            serviceId: this.serviceId,
            notificationId: this.notification.id
          })
        } else {
          response = await this.createServiceNotification({
            data: this.form,
            serviceId: this.serviceId
          })
        }

        if (response.status >= 400) {
          const msg = response.data.errors[0]
          this.$root.$bvToast.toast(msg, {
            title: 'Oops!!',
            variant: 'danger'
          })
        }
        this.$emit('done')
      }
    }
  }
}
</script>

